import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatDialog } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { SharedService } from '../../../shared/services/shared.service';
import { InvestmentInCompaniesModel } from './investment-incompanies.model';
import { InvestmentInCompaniesFormComponent } from './investment-incompanies-form.component';
import { InvestmentInCompaniesService } from './investment-incompanies.service';

@Component({
    selector: 'convfact-dialog-import-account-investment-incompanies',
    templateUrl: './investmentInCompanies-dialog-importAccount.component.html',
    styleUrls: ['./investment-incompanies.component.css'],
    standalone: false
})
export class InvestmentInCompaniesDialogImportAccount {

    dataImport: InvestmentInCompaniesModel = this.data.dataImport;

    constructor(
        public dialogRef: MatDialogRef<InvestmentInCompaniesFormComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public snackBar: MatSnackBar,
        public investmentInCompaniesService: InvestmentInCompaniesService,
        public sharedService: SharedService
    ) { }

    startImport() {
        this.sharedService.importAccountsUpdate(this.dataImport, "Financial").then(result => {
            this.dialogRef.close();
        });
    }

    closeDialog() {
        this.dialogRef.close();
    }




}
